<template>
  <div
    :data-component-name="$options.name"
    class="card"
    :class="classObject"
    :style="[
      { 'border-color': content.borderColor },
      { 'background-size': content.backgroundType },
      styleObject,
    ]"
  >
    <b-link
      v-if="content.lien && content.lien.field !== 'aucunLien'"
      :id="content['@id']"
      v-bind="jel_getLienBinding(content.lien)"
      :ga-img-name="imageName"
      class="stretched-link offre-speciale"
      :data-tag="`${jel_getNomRouteCourante()} - ${content.titre.replace(/&nbsp;/g, ' ')} - ${
        content.sousTitre
      } - ${content.dataTag}`"
    >
    </b-link>
    <div
      v-if="content.formatAffichage"
      class="content text-left container_media h-100"
      :info-format-affichage="content.formatAffichage"
      :class="[content.formatAffichage + '_container']"
      :ga-img-name="imageName"
      :data-tag="
        'MediaImage' +
        ' ' +
        content.GaLabel +
        ' ' +
        content.formatAffichage.charAt(0).toUpperCase() +
        content.formatAffichage.slice(1) +
        '-' +
        content.dataTag
      "
    >
      <component
        :is="
          'MediaImage' +
          content.formatAffichage.charAt(0).toUpperCase() +
          content.formatAffichage.slice(1)
        "
        :key="content['@id']"
        :content="content"
      >
      </component>

      <div class="text-sizer"></div>
    </div>
  </div>
</template>

<script>
import MediaImageTexteSurImage from './MediaImageTexteSurImage.vue';
import MediaImageImg60txt40 from './MediaImageImg60txt40.vue'; // Accueil fun fact
import MediaImageImg50tit10txt40 from './MediaImageImg50tit10txt40.vue'; // Accueil Pourquoi jouer?
import MediaImageTit25img50txt25 from './MediaImageTit25img50txt25.vue'; // Offres du moment
import MediaImageImg70tit30 from './MediaImageImg70tit30.vue'; // À découvrir
import MediaImageOffreSpecial from './MediaImageOffreSpecial.vue'; // Offre Spéciale (haut)
import MediaImageImg90tit10 from './MediaImageImg90tit10.vue'; // Offre Spéciale (bas)
import MediaImageIcoTitTxt from './MediaImageIcoTitTxt.vue'; // Jeux
import MediaImageGagnantPromo from './MediaImageGagnantPromo.vue'; // Gagnant Promo
import MediaImageJouerMaintenant from './MediaImageJouerMaintenant.vue'; // Jouer Maintenant
import MediaImageGif from './MediaImageGif.vue';

// Note: Ajouter le composant dans "components" ci-après

export default {
  name: 'BingoMediaImage',
  components: {
    MediaImageTexteSurImage,
    MediaImageImg60txt40,
    MediaImageImg50tit10txt40,
    MediaImageTit25img50txt25,
    MediaImageImg70tit30,
    MediaImageOffreSpecial,
    MediaImageImg90tit10,
    MediaImageIcoTitTxt,
    MediaImageGagnantPromo,
    MediaImageJouerMaintenant,
    MediaImageGif,
  },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      classObject: [
        this.jel_getClassObject(this.content),
        this.content.shadow && this.content.shadow != 'false' ? 'drop_shadow' : '',
        this.content.coinArrondi,
      ],
      isBingo: window.location.href.indexOf('/bingo/') > 0,
    };
  },
  computed: {
    styleObject() {
      return {
        'background-color':
          this.content.fondCouleur?.field === 'couleurEdit'
            ? this.content.fondCouleur.secBgThemeColor
            : 'transparent',
        'background-image': this.content.imageFond
          ? `url(${this.jel_getFichierSrc(this.content.imageFond)})`
          : null,
        'background-repeat': 'no-repeat',
        'background-position': 'left center',
        overflow: 'visible',
      };
    },
    imageName() {
      if (
        this.content.imageFond &&
        this.jel_getFichierSrc(this.content.imageFond) &&
        this.jel_getFichierSrc(this.content.imageFond).length > 0
      ) {
        return this.content.imageFond['@name'];
      }
      if (
        this.content.image &&
        this.jel_getFichierSrc(this.content.image) &&
        this.jel_getFichierSrc(this.content.image).length > 0
      ) {
        return this.content.image['@name'];
      }
      return '';
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
  },
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.main-bingo {
  .container_media {
    display: flex;
    flex-direction: column;
    overflow: visible;
    justify-content: center;
  }
}
.noBorder {
  border: none;
}

.coin_haut {
  border-top-left-radius: ms(3);
  border-top-right-radius: ms(3);
}

.coin_bas {
  border-bottom-left-radius: ms(3);
  border-bottom-right-radius: ms(3);
}

.main-bingo {
  .margin_1_mediaImage {
    margin-top: 15%;
  }
  .margin_2_mediaImage {
    margin-top: 30%;
  }
}

.stretched-link {
  z-index: 100;
}

@media screen and (max-width: 768px) {
  // si on mets des marges pour avoir les components en cascade on mets les marge à 0 içi quand ça tombe en mobile.
  .main-bingo {
    .margin_1_mediaImage {
      margin-top: 0;
    }
    .margin_2_mediaImage {
      margin-top: 0;
    }
  }
}

.square_container {
  //defini pour les tit25img50txt25
  width: 95%;
  padding-bottom: 95%;
}

.tit25img50txt25_container {
  // positionne le contenu pour les composantes suivantes
  position: absolute !important;
  height: 100%;
  /* bottom: 0; */
  left: 0;
  top: 0;
}

.drop_shadow {
  box-shadow: 1px 1px 20px -10px #555;
}

.no_border {
  border: 0px !important;
}

.h-98 {
  height: 98% !important;
}

.h-340px {
  height: 340px !important;
}

.h-380px {
  height: 380px !important;
  @include media-breakpoint-down(sm) {
    height: 300px !important;
  }
}

.card {
  border: none;
  margin-left: 2rem;
  margin-right: 2rem;

  &:has(.img70tit30_container) {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}

@include media-breakpoint-down(sm) {
  .no_rounded_corner_sm {
    border-radius: unset !important;
  }
}

.center_image_offres {
  @media (orientation: portrait) {
    @include media-breakpoint-down(sm) {
      background-position-y: -75px !important;
    }
  }

  @media (orientation: landscape) {
    @include media-breakpoint-down(md) {
      background-position-y: -75px !important;
    }
  }
}
.format-carte {
  min-height: 20rem;
}
</style>
